export enum MensajesFijosEnum {
    ERROR_SERVIDOR = 'No se pudo completar la operación',
    ALERTA_REQUERIDO = 'Falta un campo requerido',
    OPERACION_EXITOSA = '',
    CONFIRMACION_OPERACION = '¿Está seguro que desea eliminar el registro?',
    SIN_PRODUCTOS_AGREGADOS = 'Es necesario agregar un producto a la compra',
    CAMBIAR_DOMICILIO = '¿Desea cambiar el domicilio para entrega?',
    CONFIRMAR_COMPRA_DOMICILIO = '¿Favor de seleccionar un domicilio antes de confirmar su compra?',
    BUSQUEDA_SIN_RESULTADOS = 'Sin resultados',
    ARBOL_SIN_HIJOS = 'Actualmente no tienes usuarios patrocinados o no están activos.',
}
